"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./TextArea.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var TextArea = function TextArea(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? "Your Label" : _ref$label,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "Enter your text" : _ref$placeholder,
    value = _ref.value,
    onChange = _ref.onChange,
    className = _ref.className,
    disabled = _ref.disabled;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "textareafield ".concat(className || ""),
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement("textarea", {
    placeholder: placeholder,
    value: value,
    onChange: onChange
  }), /*#__PURE__*/_react["default"].createElement("label", null, label));
};
var _default = exports["default"] = TextArea;